import {Injectable} from '@angular/core';
import {BaseService} from "@core/service/base.service";
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {catchError, tap} from "rxjs/operators";
import {Observable} from "rxjs/index";

@Injectable({
  providedIn: 'root'
})
export class CertificateService extends BaseService {
  constructor(http: HttpClient) {
    super(http);
  }

  private url = 'api/certificate';

  getUrl(): string {
    return this.url;
  }

}
